<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <h2>{{ $t('enum.storeInfo') }}</h2>
    </div>
    <div>
      <ul class="main_tabs">
        <li @click="MsgTabs(0)" :class="msgTabs==0?'on':''">{{ $t('enum.basicInfo') }}</li>
        <li @click="MsgTabs(1)" :class="msgTabs == 1 ? 'on' : ''">{{ $t('enum.shipsFrom') }}</li> 
      </ul>
    </div>
    <div class="" v-show="msgTabs == 0">
      <el-form ref="FormStoreInfo" :model="FormData" :rules="rules" v-loading="loading">
        <div class="store_box">
          <div class="store_title">{{ $t('enum.storeName') }}</div>
          <p v-if="!isInfo" class="store_detail">{{ UserDetail.StoreName }}</p>
          <el-form-item v-if="isInfo" prop="StoreName">
            <el-input class="store_ipt" v-model="FormData.StoreName" @input="CheckVal('StoreName', 0)" placeholder="Please enter store name">
            </el-input>
          </el-form-item>
          <!-- <div v-if="isInfo">
            <el-input class="store_ipt" v-model="FormData.StoreName" placeholder="Please enter store name"></el-input>
          </div> -->
        </div>
        <div class="store_box">
          <div class="store_title">{{ $t('enum.storeLogo') }}</div>
          <el-image v-if="!isInfo" class="like_img" lazy :src="UserDetail.StoreLogo ? UserDetail.StoreLogo + $store.state.thumbnail : '/static/images/noimg.svg'" fit="contain"></el-image>
          <upload-images v-show="isInfo" ref="UploadImages" @returnImgs="setStoreLogo" :needReturn="true" :imgCropper="true">
          </upload-images>
        </div>
        <div class="store_box">
          <div class="store_title">{{ $t('enum.aboutMyStore') }}</div>
          <p v-if="!isInfo" class="store_detail">{{ UserDetail.AboutStore }}</p>
          <el-form-item v-if="isInfo" prop="AboutStore">
            <el-input class="store_textarea" type="textarea" :rows="4" placeholder="Try to introduce your store" v-model="FormData.AboutStore" @input="CheckVal('AboutStore')" maxlength="200" show-word-limit></el-input>
          </el-form-item>
          <!-- <el-input v-if="isInfo" class="store_textarea" type="textarea" :rows="4" placeholder="Try to introduce your store" v-model="FormData.AboutStore" maxlength="200" show-word-limit></el-input> -->
        </div>
        <div v-if="false">
          <!-- 现阶段隐藏20230207:Store Email、Paypal For Store、Phone Number -->
          <div class="store_box">
            <div class="store_title">Store Email</div>
            <p v-if="!isInfo" class="store_detail">{{ UserDetail.StoreEmail }}</p>
            <el-form-item v-if="isInfo" prop="StoreEmail">
              <el-input class="store_ipt" v-model="FormData.StoreEmail" placeholder="Please enter store Email"></el-input>
            </el-form-item>
            <!-- <el-input v-if="isInfo" class="store_ipt" v-model="FormData.StoreEmail" placeholder="Please enter store Email"></el-input> -->
          </div>
          <div class="store_box">
            <div class="store_title">Paypal For Store</div>
            <p v-if="!isInfo" class="store_detail">{{ UserDetail.Paypal }}</p>
            <el-form-item v-if="isInfo" prop="Paypal">
              <el-input class="store_ipt" v-model="FormData.Paypal" placeholder="Please enter Paypal for Store"></el-input>
            </el-form-item>
            <!-- <el-input v-if="isInfo" class="store_ipt" v-model="FormData.Paypal" placeholder="Please enter Paypal for Store"></el-input> -->
          </div>
          <div class="store_box">
            <div class="store_title">Phone Number</div>
            <p v-if="!isInfo" class="store_detail">{{ UserDetail.StorePhone }}</p>
            <el-form-item v-if="isInfo" prop="StorePhone">
              <el-input class="store_ipt" v-model="FormData.StorePhone" placeholder="Please enter Phone Number"></el-input>
            </el-form-item>
            <!-- <el-input v-if="isInfo" class="store_ipt" v-model="FormData.StorePhone" placeholder="Please enter Phone Number"></el-input> -->
          </div>
        </div>
        <div class="store_box store_btn_box">
          <div class="store_btn primary" v-if="!isInfo" @click="IsInfo">{{ $t('button.edit') }}</div>
          <div class="store_btn" v-if="isInfo" @click="isInfo = false">{{ $t('button.cancel') }}</div>
          <div class="store_btn primary" :disabled="disabled" v-if="isInfo" @click="getData('save')">{{ $t('button.save') }}</div>
        </div>
      </el-form>
    </div>
    <div class="" v-show="msgTabs == 1">
      <div class="store_box">
        <div class="store_title">{{ $t('enum.shipsFrom') }}</div>
        <p class="store_detail">
          {{ $store.state.UserDetail.Country ? $store.state.UserDetail.Country : '' }} - {{ $store.state.UserDetail.State ? $store.state.UserDetail.State : '' }}
          <router-link class="" :to="{ path: '/store/origin' }">{{ $t('button.edit') }}</router-link>
        </p>
        <!-- <p class="store_detail">{{UserDetail.NickName}}</p> -->
      </div>
      <!-- 运费模板 -->
      <!-- <div class="store_box">
        <div class="store_title">Shipping Template</div>
        <div class="store_detail">
          <community-postages ref="CommunityPostages" :showOnly="true"></community-postages>
          Default Template
          <router-link class="" :to="{ path: '/store/shipment' }">Edit</router-link>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import UploadImages from '@/components/upload-images'
import CommunityPostages from '@/components/community-postages'
export default {
  components: { UploadImages, CommunityPostages },
  data() {
    var userValidate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Wrong email or password.'));
      } else if (this.smsMsg) {
        callback(new Error(this.smsMsg));
      } else {
        callback();
      }
    };
    return {
      loading: false, //page loading
      FormData: {},
      disabled: false,
      tempUserDetail: {}, // 临时用户详情
      UserDetail: {},
      PageSize: 1,
      PageIndex: 1,
      isInfo: false,
      msgTabs: 0,
      imageUrl: "",
      rules: {
        StoreName: [
          { required: true, message: 'Should not be null.', trigger: 'blur' },
        ],
        AboutStore: [
          { required: true, message: 'Should not be null.', trigger: 'blur' },
        ],
        // Paypal: [
        //   { required: true, message: 'Should not be null.', trigger: 'blur' },
        // ],
        // StorePhone: [
        //   { required: true, message: 'Should not be null.', trigger: 'blur' },
        // ],
        // StoreEmail: [
        //   { required: true, message: 'Should not be null.', trigger: 'blur' },
        //   { type: 'email', message: 'Wrong email.', trigger: 'blur' },
        //   // { validator: userValidate }
        // ],
      },
    }
  },
  watch: {
    FormData: {
      handler(fd) {
        // console.log('watch:', fd);
      },
      deep: true,
    },
  },
  created(){
    
    console.log("created this.$route",this.$route);
  },
  mounted() {
    this.getData();
    // console.log("this.$store.state.UserDetail",this.$store.state.UserDetail)
    var _UserDetail = this.$store.state.UserDetail;
    this.tempUserDetail = { ..._UserDetail };
    this.UserDetail = { ..._UserDetail };
    let TabNum = this.$route.params.getTabNum;
    if (TabNum != null) {
      this.MsgTabs(TabNum)
    }
    // let _imageUrl = that.$refs.UploadImages.picList.ImageUrl;
  },
  methods: {
    getData(type) {
      let that = this;
      switch (type) {
        case 'save':
          that.$refs.FormStoreInfo.validate(function (valid) {
            if (valid) {
              that.disabled = true;
              if (that.loading) {
                that.disabled = false;
                return false;
              }
              let _FormData = that.FormData;
              if (_FormData['StoreLogo'] == '') {
                that.$message.warning('Please upload your Store Logo.');
                that.disabled = false;
                return false;
              }
              if (JSON.stringify(_FormData) == JSON.stringify(that.tempUserDetail)) {
                that.$message.warning('Please change Basic Info');
                that.disabled = false;
                return false;
              }
              that.loading = true;
              // 店铺信息
              //console.log('that.FormData', _FormData, JSON.stringify(_FormData))
              //console.log('that.tempUserDetail', that.tempUserDetail, JSON.stringify(that.tempUserDetail))
              //console.log('that.FormData==that.tempUserDetail', JSON.stringify(that.FormData) == JSON.stringify(that.tempUserDetail))
              _FormData["StoreEmail"] = "cardhobby@cardhobby.com";//StoreEmail,Paypal,StorePhone现阶段关闭20230207
              _FormData["Paypal"] = "Paypal";
              _FormData["StorePhone"] = "13900000001";
              let prm = { ..._FormData, 'UserApi': 'UserApi', }

              // that.loading = true;
              that.$post('EditStore', prm) // 编辑店铺信息
                .then((res) => {
                  if (res.Result) {
                    that.$message({
                      showClose: true,
                      message: res.Msg || 'Save Successfully',
                      type: "success",
                    });
                  } else {
                    that.$message.error(res.Msg);
                  }
                  that.getData('GetMemberInfo');
                })
                .catch((err) => {
                  console.log(err);
                  that.getData('GetMemberInfo');
                });
            } else {
              return false;
            }
          });

          break;
        case 'GetMemberInfo':
          that.$get('GetMemberInfo', `?MemberId=${that.$store.state.UserInfo.Id}`, 'UserApi') //通过用户id获取用户详情
            .then((ress) => {
              //  console.log("axios-GetMemberInfo:", ress.Data);
              if (ress.Result) {
                that.$store.state.UserDetail = ress.Data;
                that.tempUserDetail = ress.Data;
                that.$cookie.set('Card_Seller_UserDetail', JSON.stringify(ress.Data), {
                  expires: that.$store.state.exdays
                });
                setTimeout(() => {
                  that.isInfo = false;
                  that.loading = false;
                  that.disabled = false;
                  that.getData();
                }, 200);
              } else {
                // that.$message.error('Login failed');
              }
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        default:
          // let _data = JSON.parse(that.$cookie.get('Card_Seller_UserDetail'));
          let _data = that.$store.state.UserDetail;
          if (_data) {
            that.UserDetail = _data;
            // 双向数据绑定，修改数据，页面不刷新
            that.$set(that.FormData, 'StoreName', _data['StoreName']);
            that.$set(that.FormData, 'StoreLogo', _data['StoreLogo']);
            that.$set(that.FormData, 'AboutStore', _data['AboutStore']);
            that.$set(that.FormData, 'StoreEmail', _data['StoreEmail']);
            that.$set(that.FormData, 'StorePhone', _data['StorePhone']);
            that.$set(that.FormData, 'Paypal', _data['Paypal']);
          }
          // for(var key in JSON.parse(_data)){
          //   that.$set(that.FormData, key, _data[key]);
          // }
          break;
      }
    },
    setStoreLogo(vals) {
      //编辑图片后返回赋值给formdata
      let that = this;
      if (vals && vals.length && vals[0]['ImageUrl']) {
        that.FormData['StoreLogo'] = vals[0]['ImageUrl'];
      } else {
        that.FormData['StoreLogo'] = "";
      }
      console.log("that.FormData", that.FormData, that.tempUserDetail);
    },
    // 切换
    MsgTabs(val) {
      let that = this;
      that.msgTabs = val;
      var tabNum = that.msgTabs
      sessionStorage.removeItem(tabNum) //移除切换val
      sessionStorage.setItem("TabNum", val); //创建
    },
    // 判断是否填写过店铺信息
    IsInfo() {
      let that = this;
      this.isInfo = !this.isInfo
      let img = that.UserDetail.StoreLogo;

      let imgTemp = [{
        id: new Date().getTime(),
        ImageUrl: img,
        type: '',
        Sort: '',
      }];
      that.$refs.UploadImages.picListLimit = 1;
      that.$refs.UploadImages.picList = imgTemp;
    },
    //输入框验证
    CheckVal(obj, type = '') {
      let that = this;
      if (obj) {
        let val = that.FormData[obj];
        that.$set(that.FormData, obj, that.$store.getters.isEmoji(val, type));//不允许表情符
      }
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/allstore.css";
</style>



// WEBPACK FOOTER //
// src/pages/store/index.vue